//////////////////////////////////////////////////////////////////////
//
//  09/28/18
//  src/containers/MainHome.js
//
//  This file is the top level MainHome javascript file.
//
//  Here are some photos I downloaded from 'Unsplash' 
//  The images have the names below as part of the image name.
//  They would like you to give them an acknowledgment.
//
//  Photo by Jiayu Chan on Unsplash
//  Photo by Michael Mongin on Unsplash
//  Photo by Wesley Tingey on Unsplash
//  Photo by Keagan Henman on Unsplash
//  Photo by frankie cordoba on Unsplash
//  Photo by Curtis Potvin on Unsplash
//  Photo by Edward Cisneros on Unsplash
//  Photo by frankie cordoba on Unsplash
//  Photo by Diego Sulivan on Unsplash
//

import React, { Component } from 'react';
import { setBoth    } from "../store/actions/navbar";
import { COCKTAIL, BEER, RESTAURANT, MUSIC, LinkSingle } from "../components/LinkSingle";
import BarAndGrills   from "../images/Bar1.png";
import Bars           from "../images/Drinks.png";
import Restaurants    from "../images/Dining.png";
import Music          from "../images/Band.png";
import './MainHome.css';

class MainHome extends Component {
  constructor( props ) {
    super( props );
    this.state = {};
    this.onResize = this.onResize.bind( this );
  }
  getWindowWidth() {
    var width = document.documentElement.clientWidth;
    var inner = window.innerWidth;

  //console.log( "Screen Width: " + width + ", inner: " + inner );

    return Math.max( width, inner || 0 );
  }
  onResize() {
    window.requestAnimationFrame( () => {
      this.setState({
        width: this.getWindowWidth()
      });
    });
  }
  componentWillMount()   { this.setState( { width : this.getWindowWidth() }    ); }
  componentDidMount()    { window.addEventListener   ( "resize", this.onResize ); }
  componentWillUnmount() { window.removeEventListener( "resize", this.onResize ); }
  
  //
  //  What did the user select?
  //
  clickPic = ev => {
    const { ckBox   } = this.props.navbar;
    const { history } = this.props;

    var str_arr = ev.target.alt.split( " " );
    var str = str_arr[ 0 ].trim().toLowerCase();
    if( str !== "" ) {
      var search = "";
      console.log( "Click Found: " + str );
      switch( str ) {
      case "bar":           search="grills";        break;
      case "bars":          search="bars";          break;
      case "restaurants":   search="rests";         break;
      case "music":         search="music";         break;
      default:              search="grills";        break;
      }
      this.props.dispatch( setBoth( "page", search ) );

      switch( ckBox ) {
      case "map":           history.push( `${ process.env.PUBLIC_URL }/map` );     break;
      case "full":          history.push( `${ process.env.PUBLIC_URL }/full` );    break;
      case "compact":       history.push( `${ process.env.PUBLIC_URL }/compact` ); break;
      default:              history.push( `${ process.env.PUBLIC_URL }/full` );    break;
      }
    }
  }

  render() {
    const { ckBox, topSt  } = this.props.navbar;

    console.log( "MainHome - render: " );
    console.log( "Props ckBox: " + ckBox + ", topSt: " + topSt );
  //console.log( this.props );
    console.log( "Screen Width: " + this.state.width );
    var iconSize = ( this.state.width <= 600 ) ? "small" : "large" ;

    return (
      <div>

        <div id="main_grill">
          <div id="main_grill_title">
            <div id="main_grill_icon">
              <LinkSingle icolor="red" type={ BEER } size={ iconSize } />
            </div>
            <div id="main_grill_txt">
              Bar and Grills
            </div>
          </div>
          <div id="main_grill_pic">
            <img className="BarAndGrills"
                 onClick={ this.clickPic } 
                 src    ={ BarAndGrills  }
                 alt="Bar and Grills"/>
          </div>
        </div>

        <div id="main_bar">
          <div id="main_bar_title">
            <div id="main_bar_icon">
              <LinkSingle icolor="green" type={ COCKTAIL } size={ iconSize } />
            </div>
            <div id="main_bar_txt">
              Bars
            </div>
          </div>
          <div id="main_bar_pic">
            <img className="Bars"
                 onClick={ this.clickPic } 
                 src    ={ Bars          }
                 alt="Bars"/>
          </div>
        </div>

        <div id="main_rest">
          <div id="main_rest_title">
            <div id="main_rest_icon">
              <LinkSingle icolor="blue" type={ RESTAURANT } size={ iconSize } />
            </div>
            <div id="main_rest_txt">
              Restaurants
            </div>
          </div>
          <div id="main_rest_pic">
            <img className="Restaurants"
                 onClick={ this.clickPic } 
                 src    ={ Restaurants   }
                 alt="Restaurants"/>
          </div>
        </div>

        <div id="main_music">
          <div id="main_music_title">
            <div id="main_music_icon">
              <LinkSingle icolor="purple" type={ MUSIC } size={ iconSize } />
            </div>
            <div id="main_music_txt">
              Music
            </div>
          </div>
          <div id="main_music_pic">
            <img className="Music"
                 onClick={ this.clickPic } 
                 src    ={ Music         }
                 alt="Music"/>
          </div>
        </div>

      </div>
    );
  }
}

export default MainHome;



// WEBPACK FOOTER //
// ./src/containers/MainHome.js